import {BooleanFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterDropdownBoolean} from '@aboutyou/ui-components';
import React, {FC} from 'react';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: BooleanFilterSection;

  resetFilter: (slug: string) => void;
  setFilter: (filterData: {filterId: string; filterSection: string}) => void;
};

export const FilterSectionBoolean: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilter,
}) => {
  const {label, slug} = data;

  const active = activeFilters.get(slug)?.[0] === 'true';

  const onResetFilter = (newActiveVal: boolean) => {
    setFilter({
      filterId: newActiveVal.toString(),
      filterSection: slug,
    });
    !newActiveVal && resetFilter(slug);
  };

  return (
    <FilterDropdownBoolean
      active={active}
      label={label}
      onToggle={() => (active ? onResetFilter(false) : onResetFilter(true))}
    />
  );
};
